import { Injectable, inject } from '@angular/core';

import { ToastService } from '@shared/utils/toast.service';
import { extractErrorMessage } from '@features/investment/utils/investment-form.utils';

@Injectable({ providedIn: 'root' })
export class InvestmentFeedbackService {
  private readonly toast = inject(ToastService);

  success(detail: string, summary = 'Sukces'): void {
    this.toast.success(detail, summary);
  }

  error(error: unknown, fallback: string, summary = 'Błąd'): void {
    this.toast.error(extractErrorMessage(error, fallback), summary);
  }

  errorMessage(detail: string, summary = 'Błąd'): void {
    this.toast.error(detail, summary);
  }
}
